import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VisorDataService {
  private dataSubject = new Subject<string>();

  // Expose as observable so components can subscribe
  data$ = this.dataSubject.asObservable();

  sendData(message: string) {
    this.dataSubject.next(message); // Emits data immediately to subscribers
  }
  getData() {
    return this.data$; // Return the observable for components to subscribe
  }
}